import React from 'react';
import { findByText } from 'Common/Utils';
import { IntroNotice } from './IntroNotice';
import { ClickGesture } from 'Snippets/Redundancy'
export const UpdatingRulesMessages = [
	{
		message: <IntroNotice />,
		find: 'a[data-chaperone-trigger]',
	},
	{
		message: (
			<>
				Firstly, We have to import <b>Validator</b> from <b>formydable</b>
				...
			</>
		),
		find(target) {
			return findByText(target, 'span:Validator')[0];
		},
	},
	{
		message: (
			<>
				Then we use <b>Validator</b> method <b>rulesUpdateMessage</b> to update
				the vailable rules messages...
			</>
		),
		find(target) {
			return findByText(target, 'span:rulesUpdateMessage')[0];
		},
	},
	{
		message: (
			<>
				In the first parameter of the method. We must passed the{' '}
				<b>rule name</b> of which we want to update...
			</>
		),
		find(target) {
			return findByText(target, 'span:alpha_dash')[0];
		},
	},
	{
		message: (
			<>
				In the second parameter of the method. We must passed the{' '}
				<b>new message</b> of the rule...
			</>
		),
		find(target) {
			return findByText(target, 'span:Oh')[0];
		},
	},
	{
		message: <>Now, We use the rules we updated...</>,
		find(target) {
			return findByText(target, 'span:alpha_dash')[1];
		},
	},
	{
		message: <>That was quick! Let's try out the result!</>,
		find: 'input',
		isDoneOnClick: true,
		gesture: <ClickGesture />,
		background: {
			backdropStyle: { opacity: 1 },
			highlightStyle: { backgroundColor: 'rgba(255,255,255, 1)' },
		},
	},
];
